webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Semester; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Course; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var Account = function () {
  /**
   *
   * @param {String} username Username
   * @param {Semester[]} semesters array of Semesters
   */
  function Account() {
    var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var semesters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Account);

    this.username = username;
    this.semesters = semesters;
    this.cgpa = null;
  }

  /**
   * @returns {Number} cummulated cgpa.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Account, [{
    key: 'getcgpa',
    value: function getcgpa() {
      var totalUnits = 0;
      var totalCreditPoints = 0;
      this.semesters.forEach(function (semester) {
        totalUnits += semester.totalUnits();
        totalCreditPoints += semester.totalCreditPoints();
      });
      return totalCreditPoints / totalUnits;
    }
  }]);

  return Account;
}();

var Semester = function () {
  /**
   * @param {String} semName  semester name
   * @param {Course[]} courses array of course objects
   */
  function Semester() {
    var semName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var courses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Semester);

    this.semName = semName;
    this.courses = courses;
  }

  /**
   * @returns {Number} total number of units
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Semester, [{
    key: 'totalUnits',
    value: function totalUnits() {
      var units = 0;
      this.courses.forEach(function (course) {
        units += course.unit * 1;
      });
      return units;
    }

    /**
     * @returns {Number} total credit points
     */

  }, {
    key: 'totalCreditPoints',
    value: function totalCreditPoints() {
      var totalCreditPoints = 0;
      this.courses.forEach(function (course) {
        totalCreditPoints += course.creditPoints();
      });
      return totalCreditPoints;
    }

    /**
     * @returns {Number} grade point average = tcp/tnu.
     */

  }, {
    key: 'gpa',
    value: function gpa() {
      return this.totalCreditPoints() / this.totalUnits();
    }
  }]);

  return Semester;
}();

// just in case we decide to create a method for grading system later on

var Course = function () {
  function Course() {
    var coursename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var score = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Course);

    this.coursename = coursename;
    this.unit = unit;
    this.score = score;
  }

  // TODO: allow for multiple grading systems in app.
  // csystem(classif) {
  //   let systems = {
  //     "5unit": { A: 5, B: 4, C: 3, D: 2, E: 1, F: 0 },
  //   };
  //   return systems[classif];
  // }

  /**
   * @returns {Number} Grade point based on grade letter
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Course, [{
    key: 'grade',
    value: function grade() {
      if (this.score >= 70) {
        return 'A';
      } else if (this.score >= 60) {
        return 'B';
      } else if (this.score >= 50) {
        return 'C';
      } else if (this.score >= 45) {
        return 'D';
      } else if (this.score >= 40) {
        return 'E';
      } else {
        return 'F';
      }
    }

    /**
     * @returns {Number} credit points: units * grade point
     */

  }, {
    key: 'creditPoints',
    value: function creditPoints() {
      switch (this.grade()) {
        case 'A':
          return 5 * this.unit;
        case 'B':
          return 4 * this.unit;
        case 'C':
          return 3 * this.unit;
        case 'D':
          return 2 * this.unit;
        case 'E':
          return 1 * this.unit;
        default:
          return 0 * this.unit;
      }
    }
  }]);

  return Course;
}();

var courses = [new Course()];
var semesters = [new Semester(null, courses)];

/**
 * @type {Account}
 */
var savedAccount = null;
if (localStorage) {
  savedAccount = JSON.parse(localStorage.getItem('user-0'));
  if (savedAccount !== null) {
    for (var i = 0; i < savedAccount.semesters.length; i++) {
      semesters[i] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Semester(), savedAccount.semesters[i]);
      var tempcourses = [];
      for (var j = 0; j < savedAccount.semesters[i].courses.length; j++) {
        tempcourses[j] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Course(), savedAccount.semesters[i].courses[j]);
      }
      semesters[i].courses = tempcourses;
      tempcourses = [];
    }
  }
}
// converting d semesters and courses
var activeAccount = savedAccount !== null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Account(), savedAccount) : new Account(null, semesters);
activeAccount.semesters = semesters;
var accounts = [activeAccount];

/* harmony default export */ __webpack_exports__["c"] = ({
  courses: courses,
  semesters: semesters,
  accounts: accounts,
  activeAccount: activeAccount,
  course: function course() {
    return new Course();
  }
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    activeAccount: {
      type: Object
    }
  },
  methods: {
    deleteSem: function deleteSem(index) {
      this.activeAccount.semesters.splice(index, 1);
    },
    addSem: function addSem() {
      this.activeAccount.semesters.push(new __WEBPACK_IMPORTED_MODULE_0__data__["b" /* Semester */](null, []));
    }
  }
});

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    cgpa: String
  }
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(29);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fd1d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(27);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fd1d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"top-slanted"}),_vm._v(" "),_c('div',{staticClass:"body container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('main',{staticClass:"app-holder"},[_vm._m(2),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(3)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stay-top left"},[_c('a',{staticClass:"button is-link is-small mt-4",attrs:{"href":"https://itope84.github.io/static/gpcalc-0.1.0.apk","target":"_blank"}},[_vm._v("Download App")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stay-top right"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(28),"alt":"gp-calc logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-text has-text-white has-text-centered"},[_c('h1',{staticClass:"h3 has-text-weight-bold"},[_vm._v("CGPA CALCULATOR")]),_vm._v(" "),_c('p',[_vm._v("Easily calculate and save your CGPA to keep track of your academic progress")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v("\n        Built by "),_c('span',{staticClass:"text-primary-colored"},[_vm._v("Ilesanmi Temitope (Santiago)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.c1182bc.png";

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Calculator__ = __webpack_require__(31);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Calculator',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Calculator__["a" /* default */]
  }]
}));

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77eaff89_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__(70);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77eaff89_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 32:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSemester_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2925c64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSemester_vue__ = __webpack_require__(67);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSemester_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2925c64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSemester_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Add New Semesters")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('p',[_vm._v("All Semesters")]),_vm._v(" "),_vm._l((_vm.activeAccount.semesters),function(semester,index){return _c('div',{key:("allsemester-" + index),staticClass:"semester-list-item"},[_c('div',{staticClass:"field is-flex is-vcentered is-fullwidth"},[_c('p',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(semester.semName),expression:"semester.semName"}],staticClass:"input course-input",attrs:{"type":"text","placeholder":'Semester '+(index+1)},domProps:{"value":(semester.semName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(semester, "semName", $event.target.value)}}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('button',{staticClass:"delete",staticStyle:{"margin-left":".5rem"},attrs:{"aria-label":"close"},on:{"click":function($event){_vm.deleteSem(index)}}})]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-multiline"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark"},[_vm._v("Courses:")]),_vm._v(" "),_c('span',{staticClass:"tag is-info"},[_vm._v(_vm._s(semester.courses.length))])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark"},[_vm._v("TNU:")]),_vm._v(" "),_c('span',{staticClass:"tag is-success"},[_vm._v(_vm._s(semester.totalUnits()))])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark"},[_vm._v("GPA")]),_vm._v(" "),_c('span',{staticClass:"tag is-primary"},[_vm._v(_vm._s(semester.gpa('5unit').toFixed(2)))])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('update:activeSem', index)}}},[_vm._v("Edit Courses")])])])])})],2),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-success",on:{"click":_vm.addSem}},[_vm._v("New Semester")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Done")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('span',{staticClass:"icon-mode_edit"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewCgpa_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dda3e218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewCgpa_vue__ = __webpack_require__(69);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewCgpa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dda3e218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewCgpa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("View CGPA")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body has-text-centered"},[_c('p',[_vm._v("Your CGPA iS")]),_vm._v(" "),_c('h3',{staticClass:"text-primary-colored"},[_vm._v(_vm._s(_vm.cgpa))])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Close")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('header',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("\n        Computing for "),_c('span',{staticClass:"text-primary-colored"},[_vm._v(" "+_vm._s(_vm.activeAccount.username ? _vm.activeAccount.username : "Default User"))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{attrs:{"id":"editSem"}},[_vm._v("Change semester, edit a semester or add new semesters")]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"field column is-10 is-flex"},[_c('div',{staticClass:"control has-icons-left"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeSem),expression:"activeSem"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.activeSem=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":""}},[_vm._v("Select Semester")]),_vm._v(" "),_vm._l((_vm.activeAccount.semesters),function(semester,index){return _c('option',{key:("semester-" + index),domProps:{"value":_vm.activeAccount.semesters[index]}},[_vm._v(_vm._s(semester.semName ? semester.semName : "Semester "+(index+1)))])})],2)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"button",staticStyle:{"margin-left":".5rem"},on:{"click":_vm.displayAddSem}},[_c('span',{staticClass:"icon-mode_edit"})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"buttons is-flex"},[_c('a',{staticClass:"button ml-auto bg-secondary"},[_c('span',{staticClass:"icon-visibility",on:{"click":_vm.showgp}})])])])]),_vm._v(" "),_c('table',{staticClass:"table is-fullwidth"},[_c('caption',[_vm._v("Enter Your Courses")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.activeSem.courses),function(course,index){return _c('tr',{key:("course-" + index)},[_c('td',{attrs:{"scope":"row","data-label":"Course"}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(course.coursename),expression:"course.coursename"}],staticClass:"input course-input",attrs:{"type":"text"},domProps:{"value":(course.coursename)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(course, "coursename", $event.target.value)}}}),_vm._v(" "),_vm._m(3,true)])])]),_vm._v(" "),_c('td',{attrs:{"data-label":"Units"}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(course.unit),expression:"course.unit"}],staticClass:"input course-input",attrs:{"type":"number"},domProps:{"value":(course.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(course, "unit", $event.target.value)}}}),_vm._v(" "),_vm._m(4,true)])])]),_vm._v(" "),_c('td',{attrs:{"data-label":"Score"}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(course.score),expression:"course.score"}],staticClass:"input course-input",attrs:{"type":"number"},domProps:{"value":(course.score)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(course, "score", $event.target.value)}}}),_vm._v(" "),_vm._m(5,true)])])])])}))]),_vm._v(" "),_c('p',{staticClass:"buttons is-fullwidth"},[_c('button',{staticClass:"button ml-auto mr-auto",on:{"click":_vm.addCourse}},[_vm._v("Add Course")]),_vm._v(" "),_c('a',{staticClass:"button ml-auto mr-auto",on:{"click":_vm.displayAddSem}},[_vm._v("Change semester")]),_vm._v(" "),_c('button',{staticClass:"button ml-auto mr-auto",on:{"click":_vm.save}},[_vm._v("Save Results")])]),_vm._v(" "),_c('p',{staticClass:"is-flex"},[_c('button',{staticClass:"button ml-auto mr-auto bg-secondary",on:{"click":_vm.showgp}},[_vm._v("View CGPA")])])])]),_vm._v(" "),(_vm.showAddSem)?_c('add-semester',{attrs:{"active-account":_vm.activeAccount},on:{"close":function($event){_vm.showAddSem = false},"update:activeSem":_vm.changeActiveSem}}):_vm._e(),_vm._v(" "),(_vm.showcgpa)?_c('view-cgpa',{attrs:{"cgpa":_vm.activeAccount.getcgpa().toFixed(2)},on:{"close":function($event){_vm.showcgpa = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card-header-icon",attrs:{"href":"#","aria-label":"more options"}},[_c('span',{staticClass:"icon"},[_c('span',{staticClass:"icon-shuffle is-large"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon is-small is-left"},[_c('span',{staticClass:"icon-border_color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Course")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Units")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Score")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-right"},[_c('span',{staticClass:"icon-mode_edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-right"},[_c('span',{staticClass:"icon-mode_edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-right"},[_c('span',{staticClass:"icon-mode_edit"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_AddSemester__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_ViewCgpa__ = __webpack_require__(68);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Calculator',
  components: {
    AddSemester: __WEBPACK_IMPORTED_MODULE_2__modals_AddSemester__["a" /* default */],
    ViewCgpa: __WEBPACK_IMPORTED_MODULE_3__modals_ViewCgpa__["a" /* default */]
  },
  data: function data() {
    return {
      accounts: __WEBPACK_IMPORTED_MODULE_1__data__["c" /* default */].accounts,
      activeAccount: __WEBPACK_IMPORTED_MODULE_1__data__["c" /* default */].activeAccount,
      activeSem: __WEBPACK_IMPORTED_MODULE_1__data__["c" /* default */].activeAccount.semesters[0],
      showAddSem: false,
      showcgpa: false
    };
  },


  methods: {
    addCourse: function addCourse() {
      this.activeSem.courses.push(new __WEBPACK_IMPORTED_MODULE_1__data__["a" /* Course */]());
    },
    deleteCourse: function deleteCourse(index) {
      this.activeSem.courses.splice(index, 1);
    },
    displayAddSem: function displayAddSem() {
      this.showAddSem = true;
    },
    changeActiveSem: function changeActiveSem(index) {
      this.activeSem = this.activeAccount.semesters[index];
      this.showAddSem = false;
    },
    showgp: function showgp() {
      this.showcgpa = true;
    },
    showNoLocalStorageSupport: function showNoLocalStorageSupport() {
      alert('Your browser does not support this feature');
    },
    save: function save() {
      if (localStorage) {
        localStorage.setItem('user-' + this.accounts.indexOf(this.activeAccount), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.activeAccount));
        console.log(JSON.parse(localStorage.getItem('user-' + this.accounts.indexOf(this.activeAccount))));
        alert('Result saved successfully, you can close your browser now');
      } else {
        this.showNoLocalStorageSupport();
      }
    }
  }
});

/***/ })

},[20]);


// WEBPACK FOOTER //
// static/js/app.459d81b22980fc34eada.js